module.exports = __webpack_public_path__ + "static/Mobilecoin-3d16779ab0e432a2f6c1228c5ad5d7d5.png";